"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewAddress = void 0;
var _react = require("react");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _AddNewDeliveryButton = require("../AddNewDeliveryButton");
var _AddressFormSkeleton = require("./AddressFormSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const AddressForm = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('@ori/address-form')))).DeliveryAddressForm
}));
const NewAddress = ({
  isDeliveryOptionsLoading,
  isSelectedDeliveryLoading,
  isSuggestionAvailable
}) => {
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    addressFormProps,
    isAddressFormOpen,
    lastAddressId,
    onCreateAddress,
    wasLastAddressFormActionCancelled,
    setIsAddressFormOpen
  } = (0, _addressFormContext.useAddressForm)();
  const isBasicAddressFormCondition = !isDeliveryOptionsLoading && !isSelectedDeliveryLoading && isSuggestionAvailable === false && !wasLastAddressFormActionCancelled && lastAddressId === undefined;
  const isInilineAddressFormVisible = isAddressFormOpen && lastAddressId === undefined;

  // TODO: switching analytics to adding new state?

  // (startup) opening of address form (if needed)
  (0, _react.useEffect)(() => {
    if (isBasicAddressFormCondition && !isAddressFormOpen) {
      (0, _logger.logDebug)('No addresses available. Opening inline address form automatically ...');
      onCreateAddress();
    }
  }, [isAddressFormOpen, isBasicAddressFormCondition, onCreateAddress, setIsAddressFormOpen]);

  // loading - exit or skeleton
  if (isDeliveryOptionsLoading || isSelectedDeliveryLoading || isSuggestionAvailable === undefined) {
    return null;
  }

  // no suggestions & no last action cancel yet - show directly address form
  if (isInilineAddressFormVisible) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressFormSkeleton.AddressFormSkeleton, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AddressForm, {
        ...addressFormProps
      })
    });
  }

  // address form is visible, but not for adding a new address - hide add new button in this case
  if (isAddressFormOpen) {
    return null;
  }

  // no suggestions & last action cancelled - show big button
  // suggestions - show small button
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddNewDeliveryButton.AddNewDeliveryButton, {
    label: formatMessage(isSuggestionAvailable ? 'addNew' : 'addNewAddress'),
    testId: _models.TestId.AddNewAddress,
    variant: isSuggestionAvailable ? 'small' : 'large',
    onClick: onCreateAddress
  });
};
exports.NewAddress = NewAddress;